import {ChangeDetectionStrategy, Component, computed, input, signal} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MatIcon} from "@angular/material/icon";
import {TranslateModule} from "@ngx-translate/core";
import {ManglerStemmegivningModell, StemmegivningStatus} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {Navigasjon} from "web-ng2/tjenester/Navigasjon";
import {AvatarKomponent} from "web-ng2/delt/komponenter/avatar/avatar";
import {EnumPipe} from "felles-ng2/pipes/EnumPipe";
import {fadeInnAnimasjon} from "web-ng2/delt/animasjoner";
import {ZonedDateTimeSomPlainDatePipe} from "felles-ng2/pipes/ZonedDateTimeSomPlainDatePipe";
import {FormaterPlainDatePipe} from "felles-ng2/pipes/FormaterPlainDatePipe";

const debug = initDebugger('AvstemningManglerAndresStemmeKomponent');

/**
 * Viser avstemning som mangler andres stemme
 */
@Component({
    selector: 'avstemning-mangler-andres-stemme',
    templateUrl: 'avstemning-mangler-andres-stemme.html',
    styleUrl: 'avstemning-mangler-andres-stemme.scss',
    animations: [fadeInnAnimasjon('100ms')],
    host: {'data-testid': 'møte'},
    imports: [
        MatIcon,
        TranslateModule,
        AvatarKomponent,
        EnumPipe,
        ZonedDateTimeSomPlainDatePipe,
        FormaterPlainDatePipe
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvstemningManglerAndresStemmeKomponent {

    manglerStemmegivning = input.required<ManglerStemmegivningModell>();


    antallSomHarFullfoert = computed(()=> this.manglerStemmegivning().stemmegivere.filter(s => s.status === StemmegivningStatus.fullført).length);
    viserStemmegivere = signal(false);

    constructor(private navigasjon:Navigasjon) {
    }

    visEllerSkjulAvstemningstatus(){
        this.viserStemmegivere.update(v => !v);
    }

    gaaTilAvstemningerForMoete() {
        this.navigasjon.gåTilMøteAvstemning(this.manglerStemmegivning().moete.id);
    }
}
